import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Showcase from "@/components/Showcase";
import Solutions from "@/components/Solutions";
import CaseStudies from "@/components/CaseStudies";
import SupportServices from "@/components/SupportServices";
import SpecFinder from "@/components/SpecFinder";
import Stats from "@/components/Stats";
import CtaBanner from "@/components/CtaBanner";
import QuoteForm from "@/components/QuoteForm";
import Footer from "@/components/Footer";
import { WhatsAppFloating } from "@/components/WhatsApp";

export default function Home() {
  return (
    <div data-testid="home-page" className="relative bg-white text-[#0F172A] overflow-x-hidden">
      <Navbar />
      <main>
        <Hero />
        <Showcase />
        <Solutions />
        <CaseStudies />
        <SupportServices />
        <SpecFinder />
        <Stats />
        <CtaBanner />
        <QuoteForm />
      </main>
      <Footer />
      <WhatsAppFloating />
    </div>
  );
}
